// Copyright (c) 2022 Deere & Company

import actions from '../../actions-list';

export const calculatePercentage = percentageCalc =>

    dispatch => {

        dispatch({
            percentageCalc,
            type: actions.CALCULATE_TCSM_PERCENTAGE_DEBIT_VALUE
        });

    };



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/action-creators/calculate-percentage.js